import { Container, Stack } from '@mui/material';
import ModeSwitcher from './Components/ModeSwitcher';
import { modeSwitcherAtom } from './Shared/mode.switcher';
import { useAtom } from 'jotai';
import FileArchiveList from './Components/FileArchiveList/FileArchiveList';
import SentByCenterList from './Components/SentByCenterList/SentByCenterList';

export default function FileArchive() {
  const [mode] = useAtom(modeSwitcherAtom);

  return (
    <>
      <Container>
        <Stack gap=".5em">
          <ModeSwitcher />
          {mode === 'personal' ? (
            <FileArchiveList />
          ) : (
            <SentByCenterList />
          )}
        </Stack>
      </Container>
    </>
  );
}
